<app-devops-placeholder-card
  titleKey="liveDashboard.devops.kpisTitle"
  descriptionKey="liveDashboard.devops.description"
/>
